export default __webpack_public_path__ + "static/media/icon_11.c89355cd.png";